"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL DocumentService
 * The EMIL DocumentService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsApi = exports.DocumentsApiFactory = exports.DocumentsApiFp = exports.DocumentsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
var DocumentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This will create a document in database and upload the file to Amazon Simple Storage Service (S3).
         * @summary Create the document
         * @param {CreateDocumentRequestDto} createDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: function (createDocumentRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createDocumentRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createDocument', 'createDocumentRequestDto', createDocumentRequestDto);
                            localVarPath = "/documentservice/v1/documents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createDocumentRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will create a URL that allows user upload its documents in Database.The URL will be expires between 5 minutes to 7 days.
         * @summary Upload documents using pre-signed URL
         * @param {CreatePresignedPostRequestDto} createPresignedPostRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresignedPost: function (createPresignedPostRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPresignedPostRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createPresignedPost', 'createPresignedPostRequestDto', createPresignedPostRequestDto);
                            localVarPath = "/documentservice/v1/documents/pre-signed-post";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPresignedPostRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Permanently deletes the document. Supply the unique code that was returned when you created the document and this will delete it.
         * @summary Delete the document
         * @param {string} code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: function (code, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDocument', 'code', code);
                            localVarPath = "/documentservice/v1/documents/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will return a presigned URL to download the document.
         * @summary Fetches a document download URL
         * @param {string} code Document code
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl: function (code, authorization, contentDisposition, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('getDocumentDownloadUrl', 'code', code);
                            localVarPath = "/documentservice/v1/documents/{code}/download-url"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (contentDisposition !== undefined) {
                                localVarQueryParameter['contentDisposition'] = contentDisposition;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will return a presigned URL for a random S3 key
         * @summary Fetches a presigned URL for a S3 key
         * @param {string} s3Key Key for the file in S3 bucket to create the presigned download URL for
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedS3keyUrl: function (s3Key, authorization, contentDisposition, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 's3Key' is not null or undefined
                            (0, common_1.assertParamExists)('getSignedS3keyUrl', 's3Key', s3Key);
                            localVarPath = "/documentservice/v1/documents/signed-s3-url";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (s3Key !== undefined) {
                                localVarQueryParameter['s3Key'] = s3Key;
                            }
                            if (contentDisposition !== undefined) {
                                localVarQueryParameter['contentDisposition'] = contentDisposition;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of documents you have previously created.        The documents are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List documents
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size
         * @param {string} [pageToken] Page token
         * @param {string} [filter] List filter
         * @param {string} [search] Search query
         * @param {string} [order] Ordering criteria
         * @param {string} [expand] Extra fields to fetch
         * @param {string} [filters] List filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/documentservice/v1/documents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the document
         * @param {string} code
         * @param {UpdateDocumentRequestDto} updateDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: function (code, updateDocumentRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('updateDocument', 'code', code);
                            // verify required parameter 'updateDocumentRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updateDocument', 'updateDocumentRequestDto', updateDocumentRequestDto);
                            localVarPath = "/documentservice/v1/documents/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDocumentRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiAxiosParamCreator = DocumentsApiAxiosParamCreator;
/**
 * DocumentsApi - functional programming interface
 * @export
 */
var DocumentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * This will create a document in database and upload the file to Amazon Simple Storage Service (S3).
         * @summary Create the document
         * @param {CreateDocumentRequestDto} createDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: function (createDocumentRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDocument(createDocumentRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will create a URL that allows user upload its documents in Database.The URL will be expires between 5 minutes to 7 days.
         * @summary Upload documents using pre-signed URL
         * @param {CreatePresignedPostRequestDto} createPresignedPostRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresignedPost: function (createPresignedPostRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPresignedPost(createPresignedPostRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Permanently deletes the document. Supply the unique code that was returned when you created the document and this will delete it.
         * @summary Delete the document
         * @param {string} code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: function (code, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDocument(code, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will return a presigned URL to download the document.
         * @summary Fetches a document download URL
         * @param {string} code Document code
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl: function (code, authorization, contentDisposition, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDocumentDownloadUrl(code, authorization, contentDisposition, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will return a presigned URL for a random S3 key
         * @summary Fetches a presigned URL for a S3 key
         * @param {string} s3Key Key for the file in S3 bucket to create the presigned download URL for
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedS3keyUrl: function (s3Key, authorization, contentDisposition, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSignedS3keyUrl(s3Key, authorization, contentDisposition, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of documents you have previously created.        The documents are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List documents
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size
         * @param {string} [pageToken] Page token
         * @param {string} [filter] List filter
         * @param {string} [search] Search query
         * @param {string} [order] Ordering criteria
         * @param {string} [expand] Extra fields to fetch
         * @param {string} [filters] List filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listDocuments(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the document
         * @param {string} code
         * @param {UpdateDocumentRequestDto} updateDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: function (code, updateDocumentRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDocument(code, updateDocumentRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiFp = DocumentsApiFp;
/**
 * DocumentsApi - factory interface
 * @export
 */
var DocumentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentsApiFp)(configuration);
    return {
        /**
         * This will create a document in database and upload the file to Amazon Simple Storage Service (S3).
         * @summary Create the document
         * @param {CreateDocumentRequestDto} createDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocument: function (createDocumentRequestDto, authorization, options) {
            return localVarFp.createDocument(createDocumentRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will create a URL that allows user upload its documents in Database.The URL will be expires between 5 minutes to 7 days.
         * @summary Upload documents using pre-signed URL
         * @param {CreatePresignedPostRequestDto} createPresignedPostRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPresignedPost: function (createPresignedPostRequestDto, authorization, options) {
            return localVarFp.createPresignedPost(createPresignedPostRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Permanently deletes the document. Supply the unique code that was returned when you created the document and this will delete it.
         * @summary Delete the document
         * @param {string} code
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: function (code, authorization, options) {
            return localVarFp.deleteDocument(code, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will return a presigned URL to download the document.
         * @summary Fetches a document download URL
         * @param {string} code Document code
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentDownloadUrl: function (code, authorization, contentDisposition, options) {
            return localVarFp.getDocumentDownloadUrl(code, authorization, contentDisposition, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will return a presigned URL for a random S3 key
         * @summary Fetches a presigned URL for a S3 key
         * @param {string} s3Key Key for the file in S3 bucket to create the presigned download URL for
         * @param {string} [authorization] Bearer Token
         * @param {'attachment' | 'inline'} [contentDisposition] Content disposition override. Default will be depending on the document type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedS3keyUrl: function (s3Key, authorization, contentDisposition, options) {
            return localVarFp.getSignedS3keyUrl(s3Key, authorization, contentDisposition, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of documents you have previously created.        The documents are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List documents
         * @param {string} [authorization] Bearer Token
         * @param {number} [pageSize] Page size
         * @param {string} [pageToken] Page token
         * @param {string} [filter] List filter
         * @param {string} [search] Search query
         * @param {string} [order] Ordering criteria
         * @param {string} [expand] Extra fields to fetch
         * @param {string} [filters] List filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listDocuments(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified document by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the document
         * @param {string} code
         * @param {UpdateDocumentRequestDto} updateDocumentRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocument: function (code, updateDocumentRequestDto, authorization, options) {
            return localVarFp.updateDocument(code, updateDocumentRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentsApiFactory = DocumentsApiFactory;
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This will create a document in database and upload the file to Amazon Simple Storage Service (S3).
     * @summary Create the document
     * @param {DocumentsApiCreateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.createDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).createDocument(requestParameters.createDocumentRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will create a URL that allows user upload its documents in Database.The URL will be expires between 5 minutes to 7 days.
     * @summary Upload documents using pre-signed URL
     * @param {DocumentsApiCreatePresignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.createPresignedPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).createPresignedPost(requestParameters.createPresignedPostRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Permanently deletes the document. Supply the unique code that was returned when you created the document and this will delete it.
     * @summary Delete the document
     * @param {DocumentsApiDeleteDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.deleteDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).deleteDocument(requestParameters.code, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will return a presigned URL to download the document.
     * @summary Fetches a document download URL
     * @param {DocumentsApiGetDocumentDownloadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.getDocumentDownloadUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).getDocumentDownloadUrl(requestParameters.code, requestParameters.authorization, requestParameters.contentDisposition, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will return a presigned URL for a random S3 key
     * @summary Fetches a presigned URL for a S3 key
     * @param {DocumentsApiGetSignedS3keyUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.getSignedS3keyUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).getSignedS3keyUrl(requestParameters.s3Key, requestParameters.authorization, requestParameters.contentDisposition, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of documents you have previously created.        The documents are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
     * @summary List documents
     * @param {DocumentsApiListDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.listDocuments = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DocumentsApiFp)(this.configuration).listDocuments(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified document by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the document
     * @param {DocumentsApiUpdateDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.updateDocument = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).updateDocument(requestParameters.code, requestParameters.updateDocumentRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentsApi;
}(base_1.BaseAPI));
exports.DocumentsApi = DocumentsApi;
